import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  section: { paddingTop: '54px' },
  container: { margin: 'auto' },
  textBox: {
    '&*': {
      textAlign: 'center',
      '& p': { width: '75%', margin: '15px auto 0' },
    },
  },

  imgBox: { width: '50%', margin: '40px auto 0', minHeight: '231px' },

  [theme.breakpoints.up('sm')]: {
    textBox: {
      '& p': { width: '50%' },
      width: '85%',
      margin: 'auto',
      backgroundColor: 'transparent',
      position: 'relative',
      zIndex: 10,
    },
  },
  [theme.breakpoints.up('md')]: {
    section: { paddingTop: '70px' },
    container: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridGap: '61px',
      alignItems: 'center',
    },
    textBox: {
      '& *': {
        textAlign: 'right',
      },
      '& p': { width: '75%', marginLeft: 'auto', marginTop: '25px' },
    },

    imgBox: { margin: '0' },
  },
}));
export default style;
